import React from 'react';
import PropTypes from 'prop-types';
import Contact from '../components/Contact';
import ContactForm from '../components/ContactForm';
import PageIntro from '../components/PageIntro';
import PageContent from '../components/PageContent';
import Meta from '../components/Meta';

export default class ContactPage extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
    retryFetch: PropTypes.func
  }

  state = {
    entry: 'ota-yhteytta-id',
    data: this.props.data,
  };

  componentDidMount() {    
    window.scrollTo(0, 0);
    document.getElementsByTagName('html')[0].classList.remove('animate');
  }

  componentDidUpdate(prevProps) {
    // Update local state when props change (e.g., after data is fetched)
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  render() {
    const { loading, error, retryFetch } = this.props;

    if (error) {
      return (
        <section>
          <div className="error-container" style={{ textAlign: 'center', padding: '50px 20px' }}>
            <h2>Error loading content</h2>
            <p>{error}</p>
            <button 
              onClick={retryFetch}
              style={{
                padding: '10px 20px',
                background: '#c1347a',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '20px'
              }}
            >
              Try again
            </button>
          </div>
        </section>
      );
    }

    // Don't show anything during loading state
    if (loading) {
      return null;
    }

    return (
      <section>
        <Meta data={this.state.data} entry={this.state.entry} />
        <PageIntro data={this.state.data} entry={this.state.entry}>
          <ContactForm />
        </PageIntro>
        {/*
        <PageContent data={this.state.data} entry={this.state.entry}>
          <Contact entry={'4HGssiSmEggUYMG2Oa4aI4'} data={this.state.data} />
          <Contact entry={'5upqQWopSXfP2BZL4jiYzl'} data={this.state.data} />
        </PageContent>
        */}
      </section>
    );
  }
}
